module.exports = __webpack_public_path__ + "static/img/bg-1-2.d24bfca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m5/bg-1-2.png
// module id = zw8+
// module chunks = 1